import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrapper from './App'; 
import reportWebVitals from './reportWebVitals';
import "@fontsource/golos-text"; 
import "@fontsource/handlee"; 
import "@fontsource/montserrat";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <AppWrapper />
  </React.StrictMode>
);

reportWebVitals();
